import { useBrand } from '@contexts/useBrand'
import { updateDatalayer } from '@utils/helpers/tracking'

import { SelectInput } from '../baseInputs'

type Obj = {
  name: string
}

type Props = {
  models: Array<Obj>
  helper?: string
  optional?: boolean
  service?: string
  manufacturer?: string
  label?: string
}

const Models = ({
  helper,
  optional,
  models,
  service,
  manufacturer,
  ...rest
}: Props) => {
  const brand = useBrand()
  const name = 'model'
  const label = 'Model'

  const options = models.map((model) => {
    return {
      label: model.name,
      value: model.d4t4.id,
    }
  })

  const handleChange = (e) => {
    const selectedModel = models.filter((model) => {
      return e.target.value === model.d4t4.id
    })

    if (selectedModel.length > 0) {
      updateDatalayer('model', {
        name: selectedModel[0].name,
        id: selectedModel[0].image.id,
        brand,
        service,
        manufacturer,
      })
    } else {
      updateDatalayer('model', false)
    }
  }

  return (
    <SelectInput
      name={name}
      label={label}
      options={options}
      helper={helper}
      optional={optional}
      extraOnChange={handleChange}
      {...rest}
    />
  )
}

export default Models
